interface ISetUpInfo {
    number_min: number;
    number_max: number;
    number_default: number;
}
const onCheckSetUp = (setup: ISetUpInfo) => {
    const tmpSetup = { ...setup };
    let minScore = Number(tmpSetup.number_min || 0);
    let maxScore = Number(tmpSetup.number_max || 1);
    let defaultScore = Number(tmpSetup.number_default || 0);
    if (minScore > maxScore) {
        [minScore, maxScore] = [maxScore, minScore];
    } else if (minScore === maxScore) {
        maxScore += 1;
    }
    defaultScore = Math.min(defaultScore, maxScore);
    defaultScore = Math.max(defaultScore, minScore);
    return {
        ...tmpSetup,
        number_min: minScore,
        number_max: maxScore,
        number_default: defaultScore,
    };
};
export { onCheckSetUp };
